<template>
  <div class="sip-root">
    <router-view />
  </div>
</template>


<script>
export default {
  name: 'App',
  data() {
    return {
      step: 0,
    }
  },
  mounted() {
    window.addEventListener('keydown', this.keyEvents);
  },
  methods: {
    keyEvents(e) {
      if(e.keyCode == 32 && e.target == document.body) {
        e.preventDefault();
      }
      if(e.key === 'ArrowUp' && e.target == document.body) {
        e.preventDefault();
      }
      if(e.key === 'ArrowDown' && e.target == document.body) {
        e.preventDefault();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyEvents);
  },
}
</script>

<style lang="stylus">
@import '../node_modules/normalize.css/normalize.css'

*
  box-sizing border-box

.sip-root
  // background-color #042f3c
  background-color #FFF
  width 100%
  overflow-x hidden
  // height 100vh
  font-family 'Roboto', sans-serif

</style>
